module.exports = __webpack_public_path__ + "static/img/five.ef6a3b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/2/five.png
// module id = uOKs
// module chunks = 1